import type { ValidationError } from '@/lib/utils';
import type { User } from '@repo/shared-types';

export type UserFormValues = {
  name: string;
  email: string;
  role: User['role'];
  password: string;
  confirmPassword: string;
  // Configurations a 'client' role user may access (clients view)
  configuration_ids: string[];
};

export type UserFormProps = {
  initialValues?: Partial<UserFormValues>;
  isEditing?: boolean;
  allowProfileEdit?: boolean;
  onSubmit: (values: UserFormValues) => void;
  submitLabel?: string;
  showReset?: boolean;
  onReset?: () => void;
  errors?: ValidationError[];
  isLoading?: boolean;
};

export const defaultUserFormValues: UserFormValues = {
  name: '',
  email: '',
  role: 'user',
  password: '',
  confirmPassword: '',
  configuration_ids: [],
};

export type EditableUser = User;

export type UserModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user: EditableUser | null;
  onSubmit: (values: UserFormValues) => void;
  allowProfileEdit?: boolean;
  errors?: ValidationError[];
  isLoading?: boolean;
};
